import { useCallback, useMemo, useState } from 'react';
import { TableHeaderCell } from 'common/components';
import type { ManagerAgentAnalyticsStatus } from 'services/api/getManagerAgentAnalytics';
import { formatAgentStatus } from '../components/PerformanceAnalyticsTab.utils';

const ALL_STATUSES_VALUE = '';

const STATUS_FILTER_OPTIONS: Array<{ value: string; label: string }> = [
    { value: ALL_STATUSES_VALUE, label: 'All statuses' },
    { value: 'online', label: formatAgentStatus('online') },
    { value: 'oncall', label: formatAgentStatus('oncall') },
    { value: 'offline', label: formatAgentStatus('offline') },
];

export const usePerformanceAgentsStatusFilter = <T extends { status: ManagerAgentAnalyticsStatus }>(
    agents: T[]
) => {
    const [statusFilter, setStatusFilter] = useState(ALL_STATUSES_VALUE);

    const filteredAgents = useMemo(() => {
        if (!statusFilter) return agents;
        return agents.filter((agent) => agent.status === statusFilter);
    }, [agents, statusFilter]);

    const statusFilterHeader = useCallback(
        () => (
            <TableHeaderCell
                label='Status'
                filterOptions={{
                    options: STATUS_FILTER_OPTIONS,
                    selectedValue: statusFilter,
                    onChange: setStatusFilter,
                }}
            />
        ),
        [statusFilter]
    );

    return {
        filteredAgents,
        statusFilterHeader,
        statusFilter,
    };
};
